import React from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {LANGUAGE_PATH, useMediaQuery} from "modules";
import {Exist} from "components";
import flagIcon from "apps/DRAW_PREDICTOR/assets/images/icons/flagIcon.svg";
import preRegistrationBanner from "apps/DRAW_PREDICTOR/assets/images/icons/preRegistrationBanner.svg";
import gatesIcon from "apps/DRAW_PREDICTOR/assets/images/icons/gatesIcon.svg";
import preregistrationMobileBanner from "apps/DRAW_PREDICTOR/assets/images/icons/preregistrationMobileBanner.svg";
import {media} from "assets/css/media";
import {LockoutTimer} from "apps/DRAW_PREDICTOR/components";

const Inner = styled.div`
	max-width: 1420px;
	padding: 20px;
	margin: 0 auto;
	@media (max-width: ${media.mobile}) {
		min-height: 100%;
		padding: 0;
	}
`;

const PreregistrationWrapper = styled.div`
	width: 100%;
	height: 100%;
	background-size: cover;
	background: linear-gradient(180deg, #8a1538 -205.33%, #d20a46 186.82%);
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
	border-radius: 10px;
	font-family: "Qatar2022", sans-serif;
	margin: 20px auto 48px;
	padding: 0 20px 30px 20px;
	@media (max-width: ${media.mobile}) {
		margin-top: 0;
	}
`;

const Title = styled.h3`
	color: #dfce6d;
	font-size: 20px;
	font-weight: 900;
	text-transform: uppercase;
	font-style: italic;
`;

const SubTitle = styled.div`
	color: #ffffff;
	font-size: 30px;
	font-weight: 900;
	margin: 10px 0;
`;

const Description = styled.div`
	color: #ffffff;
	font-family: "Graphik";
	font-weight: 400;
	font-size: 20px;
	line-height: 120%;
	padding-inline-end: 5%;
	margin-bottom: 15px;

	@media (max-width: ${media.mobile}) {
		font-weight: 400;
		font-size: 14px;
		line-height: 160%;
		&.hidden-mobile {
			display: none;
		}
	}
`;

const ImagesWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 40px;
	position: relative;
	overflow: hidden;
	align-items: flex-start;
	.flag {
		margin-top: 10px;
	}
`;

const GatesIcon = styled.img`
	display: block;
`;

const MobileBanner = styled.div`
	width: 100%;
	height: 120px;
	background: url(${preregistrationMobileBanner}) top center no-repeat;
	background-size: contain;
`;

const DescriptionWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`;

interface IProps {
	isLoaded: boolean;
}

export const DrawMasthead: React.FC<IProps> = ({isLoaded}) => {
	const {t} = useTranslation(LANGUAGE_PATH);
	const isTablet = useMediaQuery(`(max-width: 990px)`);

	return (
		<Inner className="draw-first-step">
			<PreregistrationWrapper>
				<ImagesWrapper>
					<Exist when={!isTablet}>
						<img src={flagIcon} alt={"Flag"} className="flag" />
						<img src={preRegistrationBanner} alt={"Banner"} />
						<GatesIcon src={gatesIcon} alt={"Gates"} />
					</Exist>
					<Exist when={isTablet}>
						<MobileBanner />
					</Exist>
				</ImagesWrapper>
				<Title>{t("landing.page.game_name")}</Title>
				<SubTitle>{t('draw.title.header_copy')}</SubTitle>
				<DescriptionWrapper>
					<Description className="hidden-mobile">{t('draw.title.body_copy')}</Description>
					<Exist when={isLoaded}>
						<LockoutTimer />
					</Exist>
				</DescriptionWrapper>
			</PreregistrationWrapper>
		</Inner>
	);
};
